var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',{staticClass:"delivery-time-by-area"},[_c('div',{staticClass:"m-3",staticStyle:{"max-width":"1260px"}},[_c('AverageDeliveryTimeByArea',{attrs:{"title":"ระยะเวลาจัดส่งตามเขต"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }